"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyTableStyleHistoryItem = exports.ApplyParagraphStyleHistoryItem = exports.ApplyCharacterStyleHistoryItem = void 0;
var tslib_1 = require("tslib");
var history_item_1 = require("../base/history-item");
var interval_based_history_item_1 = require("../base/interval-based-history-item");
var ApplyCharacterStyleHistoryItem = (function (_super) {
    tslib_1.__extends(ApplyCharacterStyleHistoryItem, _super);
    function ApplyCharacterStyleHistoryItem(modelManipulator, subDocInterval, style, restoreHyperlinks) {
        var _this = _super.call(this, modelManipulator, subDocInterval) || this;
        _this.newStyle = style;
        _this.restoreHyperlinks = restoreHyperlinks;
        return _this;
    }
    ApplyCharacterStyleHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.style.setCharacterStyle(this.boundSubDocument, this.interval, this.newStyle, this.restoreHyperlinks);
    };
    ApplyCharacterStyleHistoryItem.prototype.undo = function () {
        this.modelManipulator.style.restoreCharacterStyle(this.boundSubDocument, this.oldState);
    };
    return ApplyCharacterStyleHistoryItem;
}(interval_based_history_item_1.IntervalBasedHistoryItem));
exports.ApplyCharacterStyleHistoryItem = ApplyCharacterStyleHistoryItem;
var ApplyParagraphStyleHistoryItem = (function (_super) {
    tslib_1.__extends(ApplyParagraphStyleHistoryItem, _super);
    function ApplyParagraphStyleHistoryItem(modelManipulator, subDocInterval, style) {
        var _this = _super.call(this, modelManipulator, subDocInterval) || this;
        _this.newStyle = style;
        return _this;
    }
    ApplyParagraphStyleHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.style.setParagraphStyle(this.boundSubDocument, this.interval, this.newStyle);
    };
    ApplyParagraphStyleHistoryItem.prototype.undo = function () {
        this.modelManipulator.style.restoreParagraphStyle(this.boundSubDocument, this.oldState);
    };
    return ApplyParagraphStyleHistoryItem;
}(interval_based_history_item_1.IntervalBasedHistoryItem));
exports.ApplyParagraphStyleHistoryItem = ApplyParagraphStyleHistoryItem;
var ApplyTableStyleHistoryItem = (function (_super) {
    tslib_1.__extends(ApplyTableStyleHistoryItem, _super);
    function ApplyTableStyleHistoryItem(modelManipulator, subDocument, tableIndex, style) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.newStyle = style;
        _this.tableIndex = tableIndex;
        _this.subDocument = subDocument;
        return _this;
    }
    ApplyTableStyleHistoryItem.prototype.redo = function () {
        this.oldStyle = this.subDocument.tables[this.tableIndex].style;
        this.modelManipulator.table.setTableStyle(this.subDocument, this.tableIndex, this.newStyle);
    };
    ApplyTableStyleHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.setTableStyle(this.subDocument, this.tableIndex, this.oldStyle);
    };
    return ApplyTableStyleHistoryItem;
}(history_item_1.HistoryItem));
exports.ApplyTableStyleHistoryItem = ApplyTableStyleHistoryItem;
